import React from 'react';
import T from 'prop-types';
import { StyleSheet, ScrollView } from 'react-native';
import appActions from '../../../../../constants/appActions';
import { NavigationService } from '../../../../../services';
import { Text, TouchableItem } from '../../../../ReusableComponents';
import { colors, dimensions, rs } from '../../../../../styles';

const s = StyleSheet.create({
  itemContainer: {
    height: 80,
    justifyContent: 'center',
    paddingHorizontal: dimensions.medium,
  },
  activeItemContainer: {
    backgroundColor: colors.grayLighter,
  },
  itemTitle: {
    lineHeight: 20,
  },
});

const NotificationAppActionScreen = ({ route }) => {
  const { selectedAppAction, onSelectAppAction } = route.params;
  const options = Object.values(appActions);

  return (
    <ScrollView style={rs.backgroundWhite}>
      {options.map((option) => {
        const isSelected = option === selectedAppAction;
        const onPress = () => {
          onSelectAppAction(isSelected ? null : option);
          NavigationService.pop();
        };

        return (
          <TouchableItem
            onPress={onPress}
            style={[s.itemContainer, isSelected && s.activeItemContainer]}
            useOpacity={false}
          >
            <Text medium semiBold style={s.itemTitle}>
              {option.toUpperCase()}
            </Text>
          </TouchableItem>
        );
      })}
    </ScrollView>
  );
};

NotificationAppActionScreen.propTypes = {
  route: T.shape({
    params: T.shape({
      selectedAppAction: T.string,
      onSelectAppAction: T.func,
    }),
  }).isRequired,
};

export default NotificationAppActionScreen;
